import React from "react";
import {BrowserRouter, Routes, Route, HashRouter, Link} from 'react-router-dom';
import Login from '../pages/Login';
import Menup from '../pages/Menup';
import Contacto from '../pages/Contacto'

function Ruteos() {

  //const rutaServidor="/";    // desarrollo
  //const rutaServidor="/smartcity";    // produccion

  return (

      // opcion con BrowserRouter (SI funcionan las API)
      /* 
      <BrowserRouter basename="/testapp">
        <Routes>
            <Route index element={<Login/>}/>
            <Route path="/login" element={<Login/>}/>

            <Route path="/menup" element={<Menup/>}/>
        </Routes>
      </BrowserRouter>
      */


      // opcion con HashRouter (NO funcionan las API)
            
      <HashRouter>
        <Routes>
          <Route index element={<Login/>}/>
          <Route path="/login" element={<Login/>}/>

          <Route path="/menup" element={<Menup/>}/>
          <Route path="/contacto" element={<Contacto/>}/>
        </Routes>
      </HashRouter>
      

  );
}

export default Ruteos;